<template>
  <div class="main">
    <van-nav-bar title="用户信息认证" />
    <div class="speepBox">
      <div class="list">
        <div class="num">1</div>
        <p>上传身份证</p>
        <div class="line"></div>
      </div>
      <div class="list">
        <div class="num">2</div>
        <p>录制视频</p>
        <div class="line"></div>
      </div>
      <div class="list active">
        <div class="num">3</div>
        <p>验证结果</p>
      </div>
    </div>
    <div class="success">
      <img src="~assets/image/success.png" alt="" style="width: 20%; display: block; margin: 0 auto;">
      <p>验证成功</p>
      <p class="text">验证已通过，请点击下一步继续您的操作</p>
    </div>
    <div class="btnSubmit">
      <van-button :disabled="isdis" round block type="info" @click="nextFn">{{btntext}}</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      btntext: '下一步',
      isdis: false
    }
  },
  mounted() {

  },
  methods: {
    nextFn() {
      this.btntext = '正在跳转...'
      this.isdis = true
      setTimeout(() => {
        this.$router.push('/examine/show')
      }, 1200);
    }
  }
}
</script>

<style lang="less" scoped>
.btnSubmit {
  width: 60%;
  margin: 0 auto;
  margin-top: 40px;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.main {
  width: 100vw;
  height: 100vh;
  background-color: #fff;  
}
.title {
  text-align: center;
  font-size: 18px;
}
.success {
  font-size: 16px;
  margin-top: 20%;
  p {
    text-align: center;
  }
  .text {
    color: #ccc;
    font-size: 14px;
  }
}
</style>
